/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/generate-component-builder/index.ts to modify the generation of this file.


import { ComponentBuilder } from '@sitecore-jss/sitecore-jss-nextjs';


import * as Accordion from 'blocks/Accordion';
import * as AccountBonus from 'blocks/AccountBonus';
import * as AccountCoupons from 'blocks/AccountCoupons';
import * as AccountJulaClubCommunicationPreferences from 'blocks/AccountJulaClubCommunicationPreferences';
import * as AccountJulaClubDetails from 'blocks/AccountJulaClubDetails';
import * as AccountJulaClubOverview from 'blocks/AccountJulaClubOverview';
import * as AccountJulaClubSignupForm from 'blocks/AccountJulaClubSignupForm';
import * as AccountJulaProAddUserForm from 'blocks/AccountJulaProAddUserForm';
import * as AccountJulaProCompanyDetails from 'blocks/AccountJulaProCompanyDetails';
import * as AccountJulaProContactDetails from 'blocks/AccountJulaProContactDetails';
import * as AccountJulaProInvoices from 'blocks/AccountJulaProInvoices';
import * as AccountJulaProOverview from 'blocks/AccountJulaProOverview';
import * as AccountJulaProSignupForm from 'blocks/AccountJulaProSignupForm';
import * as AccountJulaProUserDetails from 'blocks/AccountJulaProUserDetails';
import * as AccountJulaProUsers from 'blocks/AccountJulaProUsers';
import * as AccountMenu from 'blocks/AccountMenu';
import * as AccountOrderDetails from 'blocks/AccountOrderDetails';
import * as AccountOrderStatus from 'blocks/AccountOrderStatus';
import * as AccountPurchases from 'blocks/AccountPurchases';
import * as ActionButton from 'blocks/ActionButton';
import * as ActionButtonDouble from 'blocks/ActionButtonDouble';
import * as BlogDetails from 'blocks/BlogDetails';
import * as BlogOverview from 'blocks/BlogOverview';
import * as BrandFilterList from 'blocks/BrandFilterList';
import * as BrandHeading from 'blocks/BrandHeading';
import * as Breadcrumbs from 'blocks/Breadcrumbs';
import * as CampaignViewer from 'blocks/CampaignViewer';
import * as Cart from 'blocks/Cart';
import * as CategoryIntro from 'blocks/CategoryIntro';
import * as ChatButton from 'blocks/ChatButton';
import * as Checkout from 'blocks/Checkout';
import * as CheckoutIdentificationPage from 'blocks/CheckoutIdentificationPage';
import * as ClothingSizes from 'blocks/ClothingSizes';
import * as ContactForm from 'blocks/ContactForm';
import * as ContactHeading from 'blocks/ContactHeading';
import * as ContentBlock from 'blocks/ContentBlock';
import * as ContentBlockHighlight from 'blocks/ContentBlockHighlight';
import * as ContentBlockInfo from 'blocks/ContentBlockInfo';
import * as ContentGuide from 'blocks/ContentGuide';
import * as ContentHeading from 'blocks/ContentHeading';
import * as ContentHeadline from 'blocks/ContentHeadline';
import * as ContentIntroduction from 'blocks/ContentIntroduction';
import * as ContentLink from 'blocks/ContentLink';
import * as CreditSimulation from 'blocks/CreditSimulation';
import * as CreditWarning from 'blocks/CreditWarning';
import * as DocumentLink from 'blocks/DocumentLink';
import * as DoubleTeaser from 'blocks/DoubleTeaser';
import * as FAQArticle from 'blocks/FAQArticle';
import * as FAQHeading from 'blocks/FAQHeading';
import * as FAQOverview from 'blocks/FAQOverview';
import * as FAQSearch from 'blocks/FAQSearch';
import * as FAQSupport from 'blocks/FAQSupport';
import * as FAQs from 'blocks/FAQs';
import * as FindProduct from 'blocks/FindProduct';
import * as Flowbox from 'blocks/Flowbox';
import * as FocusGridMedia from 'blocks/FocusGridMedia';
import * as GarageConfigurator from 'blocks/GarageConfigurator';
import * as GenericForm from 'blocks/GenericForm';
import * as Hero from 'blocks/Hero';
import * as HiddenHeading from 'blocks/HiddenHeading';
import * as InformationNotice from 'blocks/InformationNotice';
import * as Inspiration from 'blocks/Inspiration';
import * as InspirationLandscape from 'blocks/InspirationLandscape';
import * as InspirationOverview from 'blocks/InspirationOverview';
import * as Links from 'blocks/Links';
import * as ManufacturerInfo from 'blocks/ManufacturerInfo';
import * as MediaBanner from 'blocks/MediaBanner';
import * as MediaCaption from 'blocks/MediaCaption';
import * as MediaDouble from 'blocks/MediaDouble';
import * as MediaDoubleWide from 'blocks/MediaDoubleWide';
import * as MediaLandscape from 'blocks/MediaLandscape';
import * as MediaLink from 'blocks/MediaLink';
import * as MediaSingle from 'blocks/MediaSingle';
import * as MediaSquare from 'blocks/MediaSquare';
import * as Menu from 'blocks/Menu';
import * as NearbyStores from 'blocks/NearbyStores';
import * as OpeningHours from 'blocks/OpeningHours';
import * as OrderConfirmation from 'blocks/OrderConfirmation';
import * as PageFooter from 'blocks/PageFooter';
import * as PageHeader from 'blocks/PageHeader';
import * as ProductArchiveSearch from 'blocks/ProductArchiveSearch';
import * as ProductCarousel from 'blocks/ProductCarousel';
import * as ProductDetails from 'blocks/ProductDetails';
import * as ProductList from 'blocks/ProductList';
import * as PromoHero from 'blocks/PromoHero';
import * as PromoStartPage from 'blocks/PromoStartPage';
import * as QuestionsAndAnswersForm from 'blocks/QuestionsAndAnswersForm';
import * as Quotation from 'blocks/Quotation';
import * as Quote from 'blocks/Quote';
import * as SearchResultsPage from 'blocks/SearchResultsPage';
import * as SharedWishlist from 'blocks/SharedWishlist';
import * as ShortcutBrands from 'blocks/ShortcutBrands';
import * as ShortcutCategories from 'blocks/ShortcutCategories';
import * as ShortcutIcons from 'blocks/ShortcutIcons';
import * as ShortcutImages from 'blocks/ShortcutImages';
import * as ShortcutInspiration from 'blocks/ShortcutInspiration';
import * as Spacer from 'blocks/Spacer';
import * as Splitter from 'blocks/Splitter';
import * as StepIndicator from 'blocks/StepIndicator';
import * as StoreIntro from 'blocks/StoreIntro';
import * as StoreList from 'blocks/StoreList';
import * as TeaserCarousel from 'blocks/TeaserCarousel';
import * as ThemedIntroductionChips from 'blocks/ThemedIntroductionChips';
import * as ThemedProductCarousel from 'blocks/ThemedProductCarousel';
import * as TopBanner from 'blocks/TopBanner';
import * as TriggerbeeCampaign from 'blocks/TriggerbeeCampaign';
import * as TrustvoiceAllReviews from 'blocks/TrustvoiceAllReviews';
import * as USP from 'blocks/USP';
import * as UserFeedbackForm from 'blocks/UserFeedbackForm';
import * as Wishlist from 'blocks/Wishlist';
import * as YouTubeVideo from 'blocks/YouTubeVideo';

export const components = new Map();

components.set('Accordion', Accordion);
components.set('AccountBonus', AccountBonus);
components.set('AccountCoupons', AccountCoupons);
components.set('AccountJulaClubCommunicationPreferences', AccountJulaClubCommunicationPreferences);
components.set('AccountJulaClubDetails', AccountJulaClubDetails);
components.set('AccountJulaClubOverview', AccountJulaClubOverview);
components.set('AccountJulaClubSignupForm', AccountJulaClubSignupForm);
components.set('AccountJulaProAddUserForm', AccountJulaProAddUserForm);
components.set('AccountJulaProCompanyDetails', AccountJulaProCompanyDetails);
components.set('AccountJulaProContactDetails', AccountJulaProContactDetails);
components.set('AccountJulaProInvoices', AccountJulaProInvoices);
components.set('AccountJulaProOverview', AccountJulaProOverview);
components.set('AccountJulaProSignupForm', AccountJulaProSignupForm);
components.set('AccountJulaProUserDetails', AccountJulaProUserDetails);
components.set('AccountJulaProUsers', AccountJulaProUsers);
components.set('AccountMenu', AccountMenu);
components.set('AccountOrderDetails', AccountOrderDetails);
components.set('AccountOrderStatus', AccountOrderStatus);
components.set('AccountPurchases', AccountPurchases);
components.set('ActionButton', ActionButton);
components.set('ActionButtonDouble', ActionButtonDouble);
components.set('BlogDetails', BlogDetails);
components.set('BlogOverview', BlogOverview);
components.set('BrandFilterList', BrandFilterList);
components.set('BrandHeading', BrandHeading);
components.set('Breadcrumbs', Breadcrumbs);
components.set('CampaignViewer', CampaignViewer);
components.set('Cart', Cart);
components.set('CategoryIntro', CategoryIntro);
components.set('ChatButton', ChatButton);
components.set('Checkout', Checkout);
components.set('CheckoutIdentificationPage', CheckoutIdentificationPage);
components.set('ClothingSizes', ClothingSizes);
components.set('ContactForm', ContactForm);
components.set('ContactHeading', ContactHeading);
components.set('ContentBlock', ContentBlock);
components.set('ContentBlockHighlight', ContentBlockHighlight);
components.set('ContentBlockInfo', ContentBlockInfo);
components.set('ContentGuide', ContentGuide);
components.set('ContentHeading', ContentHeading);
components.set('ContentHeadline', ContentHeadline);
components.set('ContentIntroduction', ContentIntroduction);
components.set('ContentLink', ContentLink);
components.set('CreditSimulation', CreditSimulation);
components.set('CreditWarning', CreditWarning);
components.set('DocumentLink', DocumentLink);
components.set('DoubleTeaser', DoubleTeaser);
components.set('FAQArticle', FAQArticle);
components.set('FAQHeading', FAQHeading);
components.set('FAQOverview', FAQOverview);
components.set('FAQSearch', FAQSearch);
components.set('FAQSupport', FAQSupport);
components.set('FAQs', FAQs);
components.set('FindProduct', FindProduct);
components.set('Flowbox', Flowbox);
components.set('FocusGridMedia', FocusGridMedia);
components.set('GarageConfigurator', GarageConfigurator);
components.set('GenericForm', GenericForm);
components.set('Hero', Hero);
components.set('HiddenHeading', HiddenHeading);
components.set('InformationNotice', InformationNotice);
components.set('Inspiration', Inspiration);
components.set('InspirationLandscape', InspirationLandscape);
components.set('InspirationOverview', InspirationOverview);
components.set('Links', Links);
components.set('ManufacturerInfo', ManufacturerInfo);
components.set('MediaBanner', MediaBanner);
components.set('MediaCaption', MediaCaption);
components.set('MediaDouble', MediaDouble);
components.set('MediaDoubleWide', MediaDoubleWide);
components.set('MediaLandscape', MediaLandscape);
components.set('MediaLink', MediaLink);
components.set('MediaSingle', MediaSingle);
components.set('MediaSquare', MediaSquare);
components.set('Menu', Menu);
components.set('NearbyStores', NearbyStores);
components.set('OpeningHours', OpeningHours);
components.set('OrderConfirmation', OrderConfirmation);
components.set('PageFooter', PageFooter);
components.set('PageHeader', PageHeader);
components.set('ProductArchiveSearch', ProductArchiveSearch);
components.set('ProductCarousel', ProductCarousel);
components.set('ProductDetails', ProductDetails);
components.set('ProductList', ProductList);
components.set('PromoHero', PromoHero);
components.set('PromoStartPage', PromoStartPage);
components.set('QuestionsAndAnswersForm', QuestionsAndAnswersForm);
components.set('Quotation', Quotation);
components.set('Quote', Quote);
components.set('SearchResultsPage', SearchResultsPage);
components.set('SharedWishlist', SharedWishlist);
components.set('ShortcutBrands', ShortcutBrands);
components.set('ShortcutCategories', ShortcutCategories);
components.set('ShortcutIcons', ShortcutIcons);
components.set('ShortcutImages', ShortcutImages);
components.set('ShortcutInspiration', ShortcutInspiration);
components.set('Spacer', Spacer);
components.set('Splitter', Splitter);
components.set('StepIndicator', StepIndicator);
components.set('StoreIntro', StoreIntro);
components.set('StoreList', StoreList);
components.set('TeaserCarousel', TeaserCarousel);
components.set('ThemedIntroductionChips', ThemedIntroductionChips);
components.set('ThemedProductCarousel', ThemedProductCarousel);
components.set('TopBanner', TopBanner);
components.set('TriggerbeeCampaign', TriggerbeeCampaign);
components.set('TrustvoiceAllReviews', TrustvoiceAllReviews);
components.set('USP', USP);
components.set('UserFeedbackForm', UserFeedbackForm);
components.set('Wishlist', Wishlist);
components.set('YouTubeVideo', YouTubeVideo);

export const componentBuilder = new ComponentBuilder({ components });

export const moduleFactory = componentBuilder.getModuleFactory();
